import React, { useState } from 'react';
import omit from 'lodash/omit';
import { NavLink, Link } from 'react-router-dom';
import Padding from './Padding.jsx';
import FontSizeOption from '../blocks/FontSizeOption.jsx';

const activeClassName = 'active-nav';

const links = [
  { to: '/enterthematic', children: '進入挑戰', exact: true },
  { to: '/enterthematic/details', children: '活動詳情' },
  { to: '/enterthematic/announcements', children: '最新消息' },

  // { to: '/app/qa', children: '常見問題' },
];

const Nav = () => {
  const [show, setShow] = useState(false);

  return (
    <nav
      className={`
        header-nav py-1 bg-white
        ${show ? 'active' : ''}
      `}
      style={{ zIndex: 100 }}
    >
      <Padding>
        <div className="row align-items-center">
          <div className="col-auto d-block d-lg-none p-0">
            <a
              className="nav-toggle"
              onClick={() => setShow(!show)}
            >
              <div></div>
              <div></div>
              <div></div>
            </a>
          </div>
          <div className="col-auto p-0 px-md-3">
            <a
              href="/"
            >
              <img className="logo" src={'assets/img/new_logo.svg'} />
            </a>
          </div>
          <div className={`
            text-center
            col-12 col-md py-4 py-md-0
            px-5 px-md-0 px-lg-3
            nav-mb-hide
          `}>
            <div className="nav nav-pills flex-column flex-md-row">
              {links.map((l, i) => (
                <NavLink
                  key={i}
                  className="
                    nav-link
                    py-1 my-1 my-md-0 mx-0 mx-xl-1
                  "
                  onClick={() => setShow(false)}
                  {...{
                    activeClassName,
                    ...omit(l, ['children']),
                  }}
                >
                  <small>{l.children}</small>
                </NavLink>
              ))}
            </div>
          </div>
          <div className={`
            col-12 col-md-auto text-center px-0
            nav-mb-hide
          `}>
            <div className="btn-sm">
              主辦機構：教育局
            </div>
            <FontSizeOption onClick={() => setShow(false)}/>
              {/* <a className="btn btn-sm btn-link" href="logout">
              登出
            </a> */}
          </div>
        </div>
      </Padding>
    </nav>
  );
};

export default Nav;
